import React, { useState, useEffect } from 'react';
import { Container, Typography, Box } from '@mui/material';
import YouTubeEmbed from '../components/YouTubeEmbed';

const Videos = () => {
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchVideos = async () => {
      try {
        setLoading(true);
        
        const response = await fetch('https://bunnyrent-backend-917484933271.us-central1.run.app/api/videos/');
        
        if (!response.ok) {
          throw new Error(`HTTP ${response.status}: ${response.statusText}`);
        }
        
        const data = await response.json();
        
        const videoList = data.results || data;
        
        setVideos(videoList);
        setError(null);
      } catch (err) {
        console.error('获取视频失败:', err);
        setError(`Failed to load videos: ${err.message}`);
      } finally {
        setLoading(false);
      }
    };

    fetchVideos();
  }, []);


  if (loading) {
    return (
      <Container maxWidth="lg" sx={{ py: 4 }}>
        <Typography variant="h4" gutterBottom sx={{ mb: 4, textAlign: 'center' }}>
          Street View Videos
        </Typography>
        <Typography variant="body1" sx={{ textAlign: 'center' }}>
          Loading videos...
        </Typography>
      </Container>
    );
  }

  if (error) {
    return (
      <Container maxWidth="lg" sx={{ py: 4 }}>
        <Typography variant="h4" gutterBottom sx={{ mb: 4, textAlign: 'center' }}>
          Street View Videos
        </Typography>
        <Typography variant="body1" sx={{ textAlign: 'center', color: 'error.main' }}>
          {error}
        </Typography>
      </Container>
    );
  }

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Typography variant="h4" gutterBottom sx={{ mb: 4, textAlign: 'center' }}>
        Street View Videos
      </Typography>

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 4, maxWidth: '800px', mx: 'auto' }}>
        {videos.length === 0 ? (
          <Typography variant="body1" sx={{ textAlign: 'center' }}>
            No videos available
          </Typography>
        ) : (
          videos.map((video) => {
            const videoId = video.youtube_id;
            if (!videoId) {
              return null;
            }

            return (
              <Box key={video.id} sx={{ width: '100%' }}>
                <YouTubeEmbed videoId={videoId} title={video.title || `Street View Video ${video.id}`} />
              </Box>
            );
          })
        )}
      </Box>
    </Container>
  );
};

export default Videos; 